import api from "./apiBase";

export const getBrandById = async (id) => {
  return api.get(`/brands/${id}`);
};

export const createBrand = async (formData) => {
  return api.post("/brands", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateBrand = async (id, formData) => {
  return api.patch(`/brands/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
